import React, { useEffect, useState } from "react";
import { useParams, useLocation, useHistory } from "react-router-dom";
import backend from "../../api";

const VerifyAccount = () => {
  const { account, token } = useParams();
  const location = useLocation();
  const history = useHistory();
  const [countdown, setCountdown] = useState(5);
  const [statusMessage, setStatusMessage] = useState(
    "Verifying your account..."
  );

  const getQueryParams = (search) => {
    const params = new URLSearchParams(search);
    return Object.fromEntries(params.entries());
  };

  const verifyEmoneyAccount = async (token) => {
    try {
      const response = await backend.post("/accounts/verify-account", {
        token,
      });
      console.log("response: ", response);

      const { redirectUrl } = getQueryParams(location.search);

      setStatusMessage("Account verified successfully! Redirecting...");

      const interval = setInterval(() => {
        setCountdown((prev) => {
          if (prev === 1) {
            clearInterval(interval);
            if (redirectUrl) {
              history.push(redirectUrl);
            }
          }
          return prev - 1;
        });
      }, 1000);
    } catch (error) {
      setStatusMessage(
        error?.response
          ? error?.response?.data?.message
          : "Failed to verify your account. Please try again."
      );
    }
  };

  useEffect(() => {
    if (account === "e-money") {
      verifyEmoneyAccount(token);
    }
  }, [token, account]);

  return (
    <section className="wishlist-section section-b-space">
      <div className="container">
        <div className="row">
          <div className="col-12 text-center">
            <h3>{statusMessage}</h3>
            {statusMessage?.includes("Redirecting") && (
              <p>
                Redirecting in {countdown} second{countdown > 1 ? "s" : ""}...
              </p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default VerifyAccount;
